import object from '@mailobj-browser/front/js/utils/object.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'
import handler from '#utilities/js/hotkey/legacy/remove.js'

const utilities = object(handler, {
  selectors: 'uid[]',
  action: 'delete',
  name: 'act'
})

export default (
  element
) => {
  hotkey(element, utilities)
}